module.exports = __webpack_public_path__ + "static/img/construccion-sostenible.8de66087.png";